import createCache from '@emotion/cache';

import { EMOTION_CACHE_KEY } from './emotion-cache-key.mjs';
import { islandEmotionStylisPlugins } from '../../build/webpack/island-emotion-stylis-plugins.js';

/**
 * Emotion cache for React islands. Scopes MUI :root rules to [data-react-island-root] and scales
 * rp-ui runtime rem values to match webstore html root.
 * @returns {import('@emotion/cache').EmotionCache}
 */
export function createIslandEmotionCache() {
	return createCache({
		key: EMOTION_CACHE_KEY,
		stylisPlugins: islandEmotionStylisPlugins(),
	});
}
